import { render, staticRenderFns } from "./StepAdvanced.vue?vue&type=template&id=39845c89&scoped=true"
import script from "./StepAdvanced.vue?vue&type=script&lang=js"
export * from "./StepAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39845c89",
  null
  
)

export default component.exports